import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { type ColumnTypeData } from '../../types/DataTable.types'

export const BudgetAccountCodeCell = ({
  hasMultiple,
  budget,
}: ColumnTypeData['BUDGET_ACCOUNTCODE']) => {
  const intl = useProcurifyIntl()

  if (hasMultiple) return <>{intl.formatMessage(messages.multipleLabel)}</>

  return <>{budget ? `${budget.accountCode} - ${budget.description}` : null}</>
}
